import useSWR from 'swr'
import { getDefaultFeeSet } from './api'

export const useDefaultFeeSet = () => useSWR('/fees/fee-set/default', getDefaultFeeSet)
